import React from 'react';
import { Button, Divider, Empty, Input, Menu, Modal, notification, Select, Spin, Typography } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import ApiService from "../../../services/ApiService";
import ModalEditFamille from "./ModalEditFamille";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;

export default class ModalAddFamille extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialstate = {
        visible: false,
        loading: true,
        id: null,
        initial: [],
        familles: [],
    };

    state = this.initialstate

    async show(id, initial) {
        await this.init()
        this.setState({ visible: true, id: id, initial: initial })
    }

    close() {
        this.setState(this.initialstate)
    }

    componentDidMount() {
        this.init()
    }

    async init() {
        var res = await ApiService.get("/contact/familles")
        if (res.success) {
            this.setState({ familles: res.items, loading: false })
        }
    }

    async onSelect(familleId) {
        var res = await ApiService.post("/contact/addfamille/" + this.state.id, { familleId: familleId })

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            })
        }
    }

    render() {
        const filteredFamilles = this.state.familles.filter(i => !this.state.initial.includes(i.id))

        return (
            <Modal
                width="40%"
                title={t`Ajouter à la famille`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <Button
                    onClick={() => this.modalEdit.show()}
                    type="primary"
                    size="large"
                    icon={<PlusOutlined />}
                >
                    <Trans>Créer une famille</Trans>
                </Button>

                <Spin spinning={this.state.loading}>
                    <Divider><Trans>Familles existantes</Trans></Divider>

                    <Menu
                        items={filteredFamilles.map((item) => ({
                            label: item.name,
                            key: item.id
                        }))}
                        onSelect={(v) => this.onSelect(v.key)}
                    />

                    {filteredFamilles.length === 0 && (
                        <Empty
                            description={t`Ajoutez de nouvelles familles dans l'onglet « Famille »`}
                        />
                    )}
                </Spin>

                <ModalEditFamille
                    getRef={(ref) => (this.modalEdit = ref)}
                    onFinish={() => this.init()}
                />
            </Modal>
        )
    }
}
